import { Box, Flex, spacing, StyleProps } from 'deepstash-ui';
import React from 'react';
import ProfileCard from 'src/components/social/ProfileCard';
import { UserData } from 'types';
import commonStrings from 'utils/strings/commonStrings';
import SubsectionHeader from '../components/SubsectionHeader';

interface TopStashersSectionProps {
  topStashers: UserData[];
  rightHeaderElement?: React.ReactElement;
}

const TopStashersSection: React.FC<TopStashersSectionProps & StyleProps> = ({
  topStashers,
  rightHeaderElement,
  ...props
}) => {
  return (
    <Box {...props}>
      <Flex justifyContent="space-between">
        <SubsectionHeader>
          {commonStrings.metacontent.topStashersSectionHeader}
        </SubsectionHeader>
        {rightHeaderElement}
      </Flex>
      <Flex flexDir="column" width="100%" gridGap={spacing.M.rem}>
        {topStashers.map(user => (
          <ProfileCard user={user} key={user.id} size={'sm'} />
        ))}
      </Flex>
    </Box>
  );
};

export default TopStashersSection;
